import cloneDeep from 'lodash/cloneDeep.js';
import merge from 'lodash/merge.js';

import Item from '@/store/quill/Item.js';

const getNamespace = type => (type.includes('temp') ? 'SectionTemplates' : 'Sections');

export default merge(
    Item({
        dates: ['created_at', 'updated_at'],
    }),
    {
        state() {
            return {
                course_id: null,
                course_template_id: null,
                created_at: null,
                description: null,
                displayDescription: null,
                displayPrerequisite: false,
                displayRelativeDates: false,
                displayStatus: {
                    editing: true,
                },
                hasChildren: false,
                id: null,
                items: [],
                objective: null,
                order: null,
                parent: null,
                parent_id: null,
                prerequisite: null,
                prerequisite_id: null,
                prerequisite_type: null,
                prerequisite_uuid: null,
                inverse_prerequisites: [],
                sectionType: null,
                section_settings: {},
                section_settings_template: {},
                title: null,
                type: null,
                updated_at: null,
                uuid: null,
                updateKey: null,
            };
        },

        getters: {},

        actions: {
            setSectionType(context, { type }) {
                context.commit('SET_SETTINGS', { type });
            },

            assignRelationships(context, { item }) {
                const namespace = getNamespace(item.type);

                if (!item.parent) {
                    context.commit('REMOVE_PARENT');
                } else {
                    const parent_id = context.rootGetters[`${namespace}/${item.parent}/get`]('id');

                    context.commit('ADD_PARENT', { item, parent_id });
                }

                context.commit('ASSIGN_ORDER', item);
            },

            removeVisibleAt({ commit, state }, isTemplate) {
                if (isTemplate) {
                    ['week_visible', 'day_visible', 'time_visible'].forEach(item => {
                        commit('EDIT_SETTINGS', {
                            settings: 'section_settings_template',
                            field: item,
                            value: null,
                        });
                    });
                }

                if (!isTemplate) {
                    commit('EDIT_SETTINGS', {
                        settings: 'section_settings',
                        field: 'visible_at',
                        value: null,
                    });
                }

                commit(
                    `${getNamespace(state.type)}/SETTINGS`,
                    {
                        uuid: state.uuid,
                        type: isTemplate ? 'section_settings_template' : 'section_settings',
                        field: 'remove_visible_at',
                        value: true,
                    },
                    {
                        root: true,
                    }
                );
            },

            removePrerequisite({ commit, state }) {
                commit('EDIT_FIELD', {
                    field: 'prerequisite',
                    value: null,
                });

                commit('EDIT_FIELD', {
                    field: 'prerequisite_id',
                    value: null,
                });

                commit('EDIT_FIELD', {
                    field: 'prerequisite_type',
                    value: null,
                });

                // Trigger auto save

                commit(
                    `${getNamespace(state.type)}/EDIT`,
                    {
                        uuid: state.uuid,
                        field: 'prerequisite_uuid',
                        value: null,
                    },
                    { root: true }
                );
            },

            setInversePrerequisites({ commit, state }, initiator) {
                const initiators = cloneDeep(state.inverse_prerequisites);

                if (!initiators.includes(initiator)) {
                    initiators.push(initiator);

                    commit('EDIT_FIELD', {
                        field: 'inverse_prerequisites',
                        value: initiators,
                    });
                }
            },

            removeInversePrerequisites({ commit, state }, target) {
                const initiators = cloneDeep(state.inverse_prerequisites);

                if (initiators.includes(target)) {
                    const index = initiators.findIndex(item => item === target);

                    initiators.splice(index, 1);

                    commit('EDIT_FIELD', {
                        field: 'inverse_prerequisites',
                        value: initiators,
                    });
                }
            },
        },

        mutations: {
            EDIT_FIELD(state, { field, value }) {
                state[field] = value;
            },

            SET_SETTINGS(state, { type }) {
                const section_settings = state.type.includes('temp') ? 'section_settings_template' : 'section_settings';

                if (!state[section_settings]) {
                    state[section_settings] = {};
                }

                state[section_settings].type = type;

                // TODO: revisit visible_at, for now set as null by default
                state[section_settings].visible_at = null;
            },

            EDIT_SETTINGS(state, { settings, field, value }) {
                if (!state[settings]) {
                    state[settings] = {};
                }

                state[settings][field] = value;
            },

            REMOVE_PARENT(state) {
                state.parent = null;
                state.parent_id = null;
            },

            ADD_PARENT(state, { item, parent_id }) {
                state.parent = item.parent;
                state.parent_id = parent_id;
            },

            ASSIGN_ORDER(state, item) {
                state.order = item.order;
            },
        },
    }
);
